var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ArrayUtils {
  static equal(array, arr) {
    if (array.length !== arr.length)
      return false;
    const keys = Object.keys(arr);
    for (let i = 0, n = keys.length; i < n; i++) {
      const key = keys[i];
      if (array[key] !== arr[key])
        return false;
    }
    return true;
  }
  static concatToSelf(array, ...items) {
    let arr = [];
    items.forEach((v) => {
      arr = arr.concat(v);
    });
    arr.forEach((v) => array.push(v));
    return array;
  }
  static unique(array, compare = (a, b) => a === b) {
    const keys = Object.keys(array);
    const ids = keys.map((v) => Number(v)).filter((v) => !isNaN(v));
    const deleteMap = {};
    for (let i = 0, n = ids.length; i < n; i++) {
      const ki = ids[i];
      if (deleteMap[ki])
        continue;
      for (let j = i + 1; j < n; j++) {
        const kj = ids[j];
        if (compare(array[ki], array[kj]))
          deleteMap[kj] = true;
      }
    }
    for (let i = ids.length - 1; i >= 0; i--) {
      const id = ids[i];
      if (deleteMap[id])
        array.splice(id, 1);
    }
    return array;
  }
  static replace(array, a, b, isAdd = true) {
    let isreplace = false;
    for (let i = 0; i < array.length; i++) {
      if (array[i] === a) {
        array[i] = b;
        isreplace = true;
        break;
      }
    }
    if (!isreplace && isAdd)
      array.push(b);
    return array;
  }
  static create(length, itemFunc) {
    const arr = [];
    for (let i = 0; i < length; i++) {
      arr[i] = itemFunc(i);
    }
    return arr;
  }
  static binarySearch(array, target, compare, start, end) {
    const insert = ArrayUtils.binarySearchInsert(array, target, compare, start, end);
    if (array[insert] === target) {
      return insert;
    }
    return -1;
  }
  static binarySearchInsert(array, target, compare, start, end) {
    if (start === void 0)
      start = 0;
    if (end === void 0)
      end = array.length;
    if (start === end) {
      return start;
    }
    if (compare(array[start], target) === 0) {
      return start;
    }
    const middle = ~~((start + end) / 2);
    if (compare(array[middle], target) < 0) {
      start = middle + 1;
    } else {
      end = middle;
    }
    return ArrayUtils.binarySearchInsert(array, target, compare, start, end);
  }
  static isUnique(array, compare = (a, b) => a === b) {
    for (let i = array.length - 1; i >= 0; i--) {
      for (let j = 0; j < i; j++) {
        if (compare(array[i], array[j])) {
          return false;
        }
      }
    }
    return true;
  }
  static deleteItem(array, item) {
    const index = array.indexOf(item);
    if (index !== -1)
      array.splice(index, 1);
    return index;
  }
}
class DataTransform {
  async blobToArrayBuffer(blob) {
    const arrayBuffer = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = function(e) {
        resolve(e.target.result);
      };
      reader.readAsArrayBuffer(blob);
    });
    return arrayBuffer;
  }
  arrayBufferToBlob(arrayBuffer) {
    const blob = new Blob([arrayBuffer]);
    return blob;
  }
  arrayBufferToUint8(arrayBuffer) {
    const u8 = new Uint8Array(arrayBuffer);
    return u8;
  }
  uint8ToArrayBuffer(uint8Array) {
    const buffer = uint8Array.buffer;
    return buffer;
  }
  arrayToArrayBuffer(array) {
    const uint8 = new Uint8Array(array);
    const buffer = uint8.buffer;
    return buffer;
  }
  uint8ArrayToArray(u8a) {
    const arr = [];
    for (let i = 0; i < u8a.length; i++) {
      arr.push(u8a[i]);
    }
    return arr;
  }
  canvasToDataURL(canvas, type = "png", quality = 1) {
    if (type === "png")
      return canvas.toDataURL("image/png");
    return canvas.toDataURL("image/jpeg", quality);
  }
  async canvasToImage(canvas, type = "png", quality = 1) {
    const dataURL = this.canvasToDataURL(canvas, type, quality);
    const img = await this.dataURLToImage(dataURL);
    return img;
  }
  async blobToDataURL(blob) {
    const dataURL = await new Promise((resolve) => {
      const a = new FileReader();
      a.onload = function(e) {
        resolve(e.target.result);
      };
      a.readAsDataURL(blob);
    });
    return dataURL;
  }
  dataURLtoBlob(dataurl) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const blob = new Blob([u8arr], { type: mime });
    return blob;
  }
  async dataURLToArrayBuffer(dataurl) {
    const blob = this.dataURLtoBlob(dataurl);
    const arrayBuffer = await this.blobToArrayBuffer(blob);
    return arrayBuffer;
  }
  async arrayBufferToDataURL(arrayBuffer) {
    const blob = this.arrayBufferToBlob(arrayBuffer);
    const dataURL = await this.blobToDataURL(blob);
    return dataURL;
  }
  async dataURLToImage(dataurl) {
    const img = await new Promise((resolve) => {
      const img2 = new Image();
      img2.onload = function() {
        resolve(img2);
      };
      img2.src = dataurl;
    });
    return img;
  }
  imageToDataURL(img, quality = 1) {
    const canvas = this.imageToCanvas(img);
    const dataurl = this.canvasToDataURL(canvas, "png", quality);
    return dataurl;
  }
  imageToCanvas(img) {
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctxt = canvas.getContext("2d");
    ctxt.drawImage(img, 0, 0);
    return canvas;
  }
  async imageToArrayBuffer(img) {
    let arraybuffer = imageBufferMap.get(img);
    if (arraybuffer) {
      return arraybuffer;
    }
    const dataUrl = this.imageToDataURL(img);
    arraybuffer = await this.dataURLToArrayBuffer(dataUrl);
    imageBufferMap.set(img, arraybuffer);
    bufferImageMap.set(arraybuffer, img);
    return arraybuffer;
  }
  imageDataToDataURL(imageData, quality = 1) {
    const canvas = this.imageDataToCanvas(imageData);
    const dataurl = this.canvasToDataURL(canvas, "png", quality);
    return dataurl;
  }
  imageDataToCanvas(imageData) {
    const canvas = document.createElement("canvas");
    canvas.width = imageData.width;
    canvas.height = imageData.height;
    const ctxt = canvas.getContext("2d");
    ctxt.putImageData(imageData, 0, 0);
    return canvas;
  }
  async imagedataToImage(imageData, quality = 1) {
    const dataUrl = this.imageDataToDataURL(imageData, quality);
    const img = await this.dataURLToImage(dataUrl);
    return img;
  }
  async arrayBufferToImage(arrayBuffer) {
    let img = bufferImageMap.get(arrayBuffer);
    if (img) {
      return img;
    }
    const dataurl = await this.arrayBufferToDataURL(arrayBuffer);
    img = await this.dataURLToImage(dataurl);
    bufferImageMap.set(arrayBuffer, img);
    imageBufferMap.set(img, arrayBuffer);
    return img;
  }
  async blobToText(blob) {
    const content = await new Promise((resolve) => {
      const a = new FileReader();
      a.onload = function(e) {
        resolve(e.target.result);
      };
      a.readAsText(blob);
    });
    return content;
  }
  stringToArrayBuffer(str) {
    const uint8Array = this.stringToUint8Array(str);
    const buffer = this.uint8ToArrayBuffer(uint8Array);
    return buffer;
  }
  async arrayBufferToString(arrayBuffer) {
    const blob = this.arrayBufferToBlob(arrayBuffer);
    const content = await this.blobToText(blob);
    return content;
  }
  async arrayBufferToObject(arrayBuffer) {
    const str = await this.arrayBufferToString(arrayBuffer);
    const obj = JSON.parse(str);
    return obj;
  }
  stringToUint8Array(str) {
    const utf8 = unescape(encodeURIComponent(str));
    const uint8Array = new Uint8Array(utf8.split("").map(function(item) {
      return item.charCodeAt(0);
    }));
    return uint8Array;
  }
  uint8ArrayToString(arr) {
    const utf8 = [].slice.apply(arr).map(function(item) {
      return String.fromCharCode(item);
    }).join("");
    const str = decodeURIComponent(escape(utf8));
    return str;
  }
}
const dataTransform = new DataTransform();
const imageBufferMap = /* @__PURE__ */ new WeakMap();
const bufferImageMap = /* @__PURE__ */ new WeakMap();
class MapUtils {
  static getKeys(map) {
    const keys = [];
    map.forEach((_v, k) => {
      keys.push(k);
    });
    return keys;
  }
  static getValues(map) {
    const values = [];
    map.forEach((v, _k) => {
      values.push(v);
    });
    return values;
  }
}
class MathUtil {
  constructor() {
    __publicField(this, "DEG2RAD", Math.PI / 180);
    __publicField(this, "RAD2DEG", 180 / Math.PI);
    __publicField(this, "PRECISION", 1e-6);
    __publicField(this, "uuid", function uuid(length = 36) {
      const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
      const id = new Array(length);
      let rnd = 0;
      let r = 0;
      return function generateUUID() {
        for (let i = 0; i < length; i++) {
          if (i === 8 || i === 13 || i === 18 || i === 23) {
            id[i] = "-";
          } else if (i === 14) {
            id[i] = "4";
          } else {
            if (rnd <= 2)
              rnd = 33554432 + Math.random() * 16777216 | 0;
            r = rnd & 15;
            rnd = rnd >> 4;
            id[i] = chars[i === 19 ? r & 3 | 8 : r];
          }
        }
        return id.join("");
      };
    }());
  }
  clamp(value, lowerLimit, upperLimit) {
    if ((value - lowerLimit) * (value - upperLimit) <= 0)
      return value;
    if (value < lowerLimit)
      return lowerLimit < upperLimit ? lowerLimit : upperLimit;
    return lowerLimit > upperLimit ? lowerLimit : upperLimit;
  }
  euclideanModulo(n, m) {
    return (n % m + m) % m;
  }
  mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
  }
  lerp(start, end, t) {
    return (1 - t) * start + t * end;
  }
  smoothstep(x, min, max) {
    if (x <= min)
      return 0;
    if (x >= max)
      return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
  }
  randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
  }
  randFloat(low, high) {
    return low + Math.random() * (high - low);
  }
  randFloatSpread(range) {
    return range * (0.5 - Math.random());
  }
  degToRad(degrees) {
    return degrees * this.DEG2RAD;
  }
  radToDeg(radians) {
    return radians * this.RAD2DEG;
  }
  isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
  }
  nearestPowerOfTwo(value) {
    return Math.pow(2, Math.round(Math.log(value) / Math.LN2));
  }
  nextPowerOfTwo(value) {
    value--;
    value |= value >> 1;
    value |= value >> 2;
    value |= value >> 4;
    value |= value >> 8;
    value |= value >> 16;
    value++;
    return value;
  }
  toRound(source, target, precision = 360) {
    return source + Math.round((target - source) / precision) * precision;
  }
  equals(a, b, precision) {
    if (precision === void 0) {
      precision = this.PRECISION;
    }
    return Math.abs(a - b) < precision;
  }
  gcd(a, b) {
    if (b)
      while ((a %= b) && (b %= a)) {
      }
    return a + b;
  }
  lcm(a, b) {
    return a * b / this.gcd(a, b);
  }
}
const mathUtil = new MathUtil();
const _ObjectUtils = class {
  static isBaseType(object) {
    if (object === void 0 || object === null || typeof object === "boolean" || typeof object === "string" || typeof object === "number") {
      return true;
    }
    return false;
  }
  static runFunc(obj, func) {
    func(obj);
    return obj;
  }
  static isObject(object) {
    return (object == null ? void 0 : object.constructor.name) === "Object";
  }
  static getPropertyValue(object, property) {
    if (typeof property === "string")
      property = property.split(".");
    let value = object;
    const len = property.length;
    for (let i = 0; i < len; i++) {
      if (_ObjectUtils.objectIsEmpty(value))
        return void 0;
      value = value[property[i]];
    }
    return value;
  }
  static getPropertyChains(object) {
    const result = [];
    const propertys = Object.keys(object);
    const hosts = new Array(propertys.length).fill(object);
    const parentPropertyIndices = new Array(propertys.length).fill(-1);
    let index = 0;
    while (index < propertys.length) {
      const host = hosts[index];
      const cp = propertys[index];
      const cv = host[cp];
      let vks;
      if (_ObjectUtils.objectIsEmpty(cv) || _ObjectUtils.isBaseType(cv) || (vks = Object.keys(cv)).length === 0) {
        const ps = [cp];
        let ci = index;
        while ((ci = parentPropertyIndices[ci]) !== -1) {
          ps.push(propertys[ci]);
        }
        ps.reverse();
        result.push(ps.join("."));
      } else {
        vks.forEach((k) => {
          propertys.push(k);
          hosts.push(cv);
          parentPropertyIndices.push(index);
        });
      }
      index++;
    }
    return result;
  }
  static assignShallow(target, source) {
    if (_ObjectUtils.objectIsEmpty(source))
      return target;
    const keys = Object.keys(source);
    keys.forEach((k) => {
      target[k] = source[k];
    });
    return target;
  }
  static assignDeep(target, source, handlers = [], deep = Number.MAX_SAFE_INTEGER) {
    if (_ObjectUtils.objectIsEmpty(source))
      return target;
    if (deep < 1)
      return target;
    const keys = Object.keys(source);
    const concatHandlers = handlers.concat(_ObjectUtils.assignDeepDefaultHandlers);
    keys.forEach((k) => {
      for (let i = 0; i < concatHandlers.length; i++) {
        if (concatHandlers[i](target, source, k, handlers, deep)) {
          return;
        }
      }
      target[k] = source[k];
    });
    return target;
  }
  static equalDeep(a, b) {
    if (a === b)
      return true;
    if (_ObjectUtils.isBaseType(a) || _ObjectUtils.isBaseType(b))
      return a === b;
    if (typeof a === "function" || typeof b === "function")
      return a === b;
    const akeys = Object.keys(a);
    const bkeys = Object.keys(b);
    if (!ArrayUtils.equal(akeys, bkeys))
      return false;
    if (Array.isArray(a) && Array.isArray(b))
      return a.length === b.length;
    for (let i = 0; i < akeys.length; i++) {
      const element = akeys[i];
      if (!_ObjectUtils.equalDeep(a[element], b[element])) {
        return false;
      }
    }
    return true;
  }
  static objectIsEmpty(obj) {
    return obj === void 0 || obj === null;
  }
  static getPropertyDescriptor(object, property) {
    const data = Object.getOwnPropertyDescriptor(object, property);
    if (data) {
      return data;
    }
    const prototype = Object.getPrototypeOf(object);
    if (prototype) {
      return _ObjectUtils.getPropertyDescriptor(prototype, property);
    }
    return void 0;
  }
  static propertyIsWritable(obj, property) {
    const data = _ObjectUtils.getPropertyDescriptor(obj, property);
    if (!data)
      return false;
    if (data.get && !data.set)
      return false;
    return true;
  }
};
let ObjectUtils = _ObjectUtils;
__publicField(ObjectUtils, "assignDeepDefaultHandlers", [
  function(target, source, key) {
    if (target[key] === source[key])
      return true;
    return false;
  },
  function(target, source, key) {
    if (_ObjectUtils.isBaseType(target[key]) || _ObjectUtils.isBaseType(source[key])) {
      target[key] = source[key];
      return true;
    }
    return false;
  },
  function(target, source, key, handlers, deep) {
    if (Array.isArray(source[key]) || _ObjectUtils.isObject(source[key])) {
      _ObjectUtils.assignDeep(target[key], source[key], handlers, deep - 1);
      return true;
    }
    return false;
  }
]);
const lazy = {
  getValue(lazyItem, ...args) {
    if (typeof lazyItem === "function") {
      return lazyItem.apply(void 0, args);
    }
    return lazyItem;
  }
};
export {
  ArrayUtils,
  DataTransform,
  MapUtils,
  MathUtil,
  ObjectUtils,
  dataTransform,
  lazy,
  mathUtil
};
//# sourceMappingURL=index.js.map
